// Timer thresholds for showing warnings and confirmation modal
export const TIMER_CONSTANTS = {
  // Thresholds for showing the confirmation modal (in seconds)
  CONFIRMATION_THRESHOLDS: [60, 10],
  
  // Thresholds for showing toast notifications (in seconds)
  WARNING_THRESHOLDS: {
    FIVE_MINUTES: 300,
    ONE_MINUTE: 60,
    THIRTY_SECONDS: 30,
    TEN_SECONDS: 10
  }
};
